(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('searchPage', () => ({
      isLoading: false,
      searchQuery: '',
      searchResult: false,
      nextPageCount: 1,
      hasNextPage: false,
      init() {
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');

        this.getHasNextPage(document, page || this.nextPageCount);

        window.onpopstate = () => {
          window.location.reload();
        };
      },
      addNextPageItems(items) {
        const collectionItemsGrid = document.getElementById('coll-grid');
        items.forEach((item) => {
          collectionItemsGrid.append(item);
        });
      },
      getHasNextPage(node, counter = 1) {
        this.nextPageCount = counter;
        this.hasNextPage = !!node.querySelector('[data-next-page]');
      },
      getNewItems(response) {
        return response.querySelectorAll('#coll-grid article');
      },
      scrollToAnchor(node) {
        const anchorBlock = node;

        if (anchorBlock) {
          const elementPosition = anchorBlock.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition +
            window.pageYOffset -
            parseFloat(document.documentElement.style.getPropertyValue('--header-height') || 0);

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      },
      changeUrl(url) {
        window.history.pushState({}, url, url);
      },
      async renderSearch() {
        this.isLoading = true;
        this.resultsCount = 0;

        const url = `/search?q=${this.searchQuery}&type=product`;
        this.changeUrl(url);

        try {
          if (!this.searchQuery.length) {
            this.searchResult = false;
            this.isLoading = false;
            return;
          }

          const currentLayout = document.getElementById(`main-search`);

          const response = await this.get(url, { responseType: 'document' });
          const newLayout = response.getElementById(`main-search`);

          if (newLayout) {
            currentLayout.outerHTML = newLayout.outerHTML;
          }

          this.searchResult = true;
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
        }
      },
      async get(url, config = {}) {
        try {
          const options = Object.assign(
            {
              method: 'GET',
              headers: config.headers || {},
            },
            config,
          );

          const response = await fetch(url, options);

          if (!response.ok) {
            throw new Error(`Fetch error: ${response.status} ${response.statusText}`);
          }

          const text = await response.text();
          return new DOMParser().parseFromString(text, 'text/html');
        } catch (e) {
          console.log(e);
        }
      },
      async loadMore(newURL) {
        this.isLoading = true;

        try {
          const response = await this.get(newURL, { responseType: 'document' });

          const newItems = this.getNewItems(response);
          if (newItems && newItems.length) {
            this.addNextPageItems(newItems);
            this.isLoading = false;
          }

          this.getHasNextPage(response, this.nextPageCount);

          this.isLoading = false;
        } catch (e) {
          console.log(e);
          this.isLoading = false;
        }
      },
      async loadMoreProducts() {
        this.nextPageCount++;

        const newURL =
          window.location.href.split('?').shift() +
          '?q=' +
          this.searchQuery +
          '&type=product&page=' +
          this.nextPageCount;
        await this.loadMore(newURL);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-feature-grid"] && !Shopify.designMode) return;
  try {
    
  const initFeatureGridLand = (root) => {
    if (!root || root.dataset.featureGridLandInit === '1') {
      return;
    }

    root.dataset.featureGridLandInit = '1';

    const base = root.querySelector('[data-feature-grid-land-base]');
    const march = root.querySelector('[data-feature-grid-land-march]');
    const fill = root.querySelector('[data-feature-grid-land-fill]');
    const nodesGroup = root.querySelector('[data-feature-grid-land-nodes]');

    if (!base || !march || !fill || !nodesGroup) {
      return;
    }

    const points = base
      .getAttribute('points')
      .trim()
      .split(/\s+/)
      .map((segment) => {
        const parts = segment.split(',');
        return [Number(parts[0]), Number(parts[1])];
      });

    for (let index = 0; index < points.length; index += 1) {
      if (index % 4 !== 0) {
        continue;
      }

      const point = points[index];
      const node = document.createElementNS('http://www.w3.org/2000/svg', 'circle');

      node.setAttribute('class', 'feature-grid__land-node');
      node.setAttribute('cx', String(point[0]));
      node.setAttribute('cy', String(point[1]));
      node.setAttribute('r', '6.5');
      nodesGroup.appendChild(node);
    }

    const nodes = Array.from(nodesGroup.children);
    const length = base.getTotalLength();

    base.style.strokeDasharray = String(length);
    base.style.strokeDashoffset = String(length);

    let rafs = [];
    let timers = [];

    const at = (delay, callback) => {
      timers.push(window.setTimeout(callback, delay));
    };

    const clearAll = () => {
      for (const frame of rafs) {
        window.cancelAnimationFrame(frame);
      }

      rafs = [];

      for (const timer of timers) {
        window.clearTimeout(timer);
      }

      timers = [];
    };

    const run = () => {
      clearAll();

      base.style.transition = 'none';
      base.style.strokeDashoffset = String(length);
      march.classList.remove('is-active');
      fill.classList.remove('is-visible');

      for (const node of nodes) {
        node.classList.remove('is-visible');
      }

      void root.offsetWidth;
      base.style.transition = '';

      at(400, () => {
        base.style.strokeDashoffset = '0';
      });

      for (let index = 0; index < nodes.length; index += 1) {
        const delay = 500 + index * (2200 / nodes.length);

        at(delay, () => {
          nodes[index].classList.add('is-visible');
        });
      }

      at(2900, () => {
        march.classList.add('is-active');
        fill.classList.add('is-visible');
      });

      at(9900, run);
    };

    let started = false;

    const start = () => {
      if (started) {
        return;
      }

      started = true;
      run();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              observer.disconnect();
              start();
            }
          }
        },
        { threshold: 0.15 },
      );

      observer.observe(root);
    }

    window.requestAnimationFrame(() => {
      const rect = root.getBoundingClientRect();

      if (rect.top < (window.innerHeight || 800) && rect.bottom > 0) {
        start();
      }
    });
  };

  // Defer the SVG measurements (getTotalLength, offsetWidth) until the element is
  // close to the viewport, so they do not force layout during page load.
  const whenNearViewport = (element, callback) => {
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            observer.disconnect();
            callback();
            return;
          }
        }
      },
      { rootMargin: '400px 0px' },
    );

    observer.observe(element);
  };

  const initFeatureGridLands = (scope = document) => {
    const roots = scope.querySelectorAll('[data-feature-grid-land]');

    for (const root of roots) {
      whenNearViewport(root, () => initFeatureGridLand(root));
    }
  };

  initFeatureGridLands();

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-id]');

    if (!section) {
      return;
    }

    initFeatureGridLands(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-neighborhood-map"] && !Shopify.designMode) return;
  try {
    
  const initPolygonMap = (root) => {
    if (!root || root.dataset.neighborhoodMapPolygonInit === '1') {
      return;
    }

    root.dataset.neighborhoodMapPolygonInit = '1';

    const buildFlag = (group) => {
      group.innerHTML =
        '<ellipse class="base" cx="0" cy="3" rx="13" ry="5"/>' +
        '<g class="body"><line class="neighborhood-map__pole" x1="0" y1="0" x2="0" y2="-64"/>' +
        '<path class="neighborhood-map__pennant" d="M0 -64 L42 -53 L0 -37 Z"/>' +
        '<circle class="neighborhood-map__knob" cx="0" cy="-65" r="4.5"/></g>';
    };

    const flags = {};
    const flagNodes = root.querySelectorAll('.neighborhood-map__flag');

    for (const flag of flagNodes) {
      buildFlag(flag);
      flags[flag.dataset.f] = flag;
    }

    const edges = Array.from(root.querySelectorAll('.neighborhood-map__edge'));

    for (const edge of edges) {
      const length = edge.getTotalLength();
      edge.dataset.len = length;
      edge.style.strokeDasharray = String(length);
      edge.style.strokeDashoffset = String(length);
    }

    const fill = root.querySelector('[data-neighborhood-map-fill]');
    const num = root.querySelector('[data-neighborhood-map-num]');
    const ping = root.querySelector('[data-neighborhood-map-ping]');
    const order = ['0', '1', '2', '3', '4', '5', '6', '7'];
    const acresTarget = parseFloat(root.dataset.acresTarget) || 18.2;

    let timers = [];
    let rafs = [];

    const at = (delay, callback) => {
      timers.push(window.setTimeout(callback, delay));
    };

    const pingGo = () => {
      if (!ping) {
        return;
      }

      ping.classList.remove('is-active');
      void ping.getBBox();
      ping.classList.add('is-active');
    };

    const countTo = (element, start, end, duration, format) => {
      let startTime = null;

      const step = (timestamp) => {
        if (!startTime) {
          startTime = timestamp;
        }

        const progress = Math.min(1, (timestamp - startTime) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);

        element.textContent = format(start + (end - start) * eased);

        if (progress < 1) {
          rafs.push(window.requestAnimationFrame(step));
        }
      };

      rafs.push(window.requestAnimationFrame(step));
    };

    const reset = () => {
      for (const timer of timers) {
        window.clearTimeout(timer);
      }

      timers = [];

      for (const frame of rafs) {
        window.cancelAnimationFrame(frame);
      }

      rafs = [];

      for (const edge of edges) {
        edge.style.transition = 'none';
        edge.style.strokeDashoffset = edge.dataset.len;
      }

      if (fill) {
        fill.classList.remove('is-visible');
      }

      for (const key of order) {
        flags[key].classList.remove('is-visible');
      }

      if (num) {
        num.textContent = '0.0';
      }

      void root.offsetWidth;

      for (const edge of edges) {
        edge.style.transition = '';
      }
    };

    const run = () => {
      reset();
      at(350, pingGo);

      let time = 600;
      const stepDelay = 560;

      for (let index = 0; index < order.length; index += 1) {
        const key = order[index];

        at(time, () => {
          flags[key].classList.add('is-visible');

          if (index > 0) {
            edges[index - 1].style.strokeDashoffset = '0';
          }
        });

        time += stepDelay;
      }

      at(time, () => {
        edges[edges.length - 1].style.strokeDashoffset = '0';
      });

      at(time + 550, () => {
        if (fill) {
          fill.classList.add('is-visible');
        }

        if (num) {
          countTo(num, 0, acresTarget, 1100, (value) => value.toFixed(1));
        }
      });

      at(time + 550 + 4200, run);
    };

    let started = false;

    const start = () => {
      if (started) {
        return;
      }

      started = true;
      run();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              observer.disconnect();
              start();
            }
          }
        },
        { threshold: 0.15 },
      );

      observer.observe(root);
    }

    window.requestAnimationFrame(() => {
      const rect = root.getBoundingClientRect();

      if (rect.top < (window.innerHeight || 800) && rect.bottom > 0) {
        start();
      }
    });
  };

  const initRadiusMap = (root) => {
    if (!root || root.dataset.neighborhoodMapRadiusInit === '1') {
      return;
    }

    root.dataset.neighborhoodMapRadiusInit = '1';

    const centerX = 740;
    const centerY = 475;
    const angle = 0;
    const radiusMin = 88;
    const radiusMax = 300;
    const feetPerUnit = 0.92;

    const disc = root.querySelector('[data-neighborhood-map-disc]');
    const ring = root.querySelector('[data-neighborhood-map-ring]');
    const spoke = root.querySelector('[data-neighborhood-map-spoke]');
    const handle = root.querySelector('[data-neighborhood-map-handle]');
    const num = root.querySelector('[data-neighborhood-map-radius-num]');

    const applyRadius = (radius) => {
      if (disc) {
        disc.setAttribute('r', radius);
      }

      if (ring) {
        ring.setAttribute('r', radius);
      }

      const handleX = centerX + Math.cos(angle) * radius;
      const handleY = centerY + Math.sin(angle) * radius;

      if (spoke) {
        spoke.setAttribute('x2', handleX);
        spoke.setAttribute('y2', handleY);
      }

      if (handle) {
        handle.setAttribute('transform', 'translate(' + handleX.toFixed(1) + ',' + handleY.toFixed(1) + ')');
      }

      if (num) {
        num.textContent = String(Math.round(radius * feetPerUnit));
      }
    };

    let rafs = [];
    let timers = [];

    const at = (delay, callback) => {
      timers.push(window.setTimeout(callback, delay));
    };

    const ease = (progress) => {
      if (progress < 0.5) {
        return 4 * progress * progress * progress;
      }

      return 1 - Math.pow(-2 * progress + 2, 3) / 2;
    };

    const tween = (from, to, duration, callback, done) => {
      let startTime = null;

      const step = (timestamp) => {
        if (!startTime) {
          startTime = timestamp;
        }

        const progress = Math.min(1, (timestamp - startTime) / duration);
        callback(from + (to - from) * ease(progress));

        if (progress < 1) {
          rafs.push(window.requestAnimationFrame(step));
        } else if (done) {
          done();
        }
      };

      rafs.push(window.requestAnimationFrame(step));
    };

    const clearAll = () => {
      for (const frame of rafs) {
        window.cancelAnimationFrame(frame);
      }

      rafs = [];

      for (const timer of timers) {
        window.clearTimeout(timer);
      }

      timers = [];
    };

    const run = () => {
      clearAll();
      applyRadius(radiusMin);

      at(700, () => {
        tween(radiusMin, radiusMax, 2100, applyRadius, () => {
          at(900, () => {
            tween(radiusMax, radiusMax * 0.62, 1500, applyRadius, () => {
              at(700, () => {
                tween(radiusMax * 0.62, radiusMax * 0.86, 1200, applyRadius, () => {
                  at(1500, run);
                });
              });
            });
          });
        });
      });
    };

    let started = false;

    const start = () => {
      if (started) {
        return;
      }

      started = true;
      run();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              observer.disconnect();
              start();
            }
          }
        },
        { threshold: 0.15 },
      );

      observer.observe(root);
    }

    window.requestAnimationFrame(() => {
      const rect = root.getBoundingClientRect();

      if (rect.top < (window.innerHeight || 800) && rect.bottom > 0) {
        start();
      }
    });
  };

  // Defer the SVG measurements (getTotalLength, offsetWidth) until the element is
  // close to the viewport, so they do not force layout during page load.
  const whenNearViewport = (element, callback) => {
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            observer.disconnect();
            callback();
            return;
          }
        }
      },
      { rootMargin: '400px 0px' },
    );

    observer.observe(element);
  };

  const initAllNeighborhoodMaps = (scope = document) => {
    const polygonMaps = scope.querySelectorAll('[data-neighborhood-map-polygon]');
    const radiusMaps = scope.querySelectorAll('[data-neighborhood-map-radius]');

    for (const map of polygonMaps) {
      whenNearViewport(map, () => initPolygonMap(map));
    }

    for (const map of radiusMaps) {
      whenNearViewport(map, () => initRadiusMap(map));
    }
  };

  initAllNeighborhoodMaps();

  document.addEventListener('shopify:section:load', (event) => {
    initAllNeighborhoodMaps(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
